import React from 'react';

class Alerta extends React.Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  color(tipo){
    switch (tipo) {
      case "warning":
        return "orange";
      case "ok":
        return "green";
      case "error":
        return "red";
      default:
        return "orange";
    }
  }

  render(){
    const {tipo, mensaje} = this.props;
    return(
      <div
        style={{
          display:'flex', width:'80%', height:60,
          justifyContent:'center', alignItems:'center', textAlign:'center',
          borderRadius: 10, margin:'30px auto -20px auto', letterSpacing:5,
          backgroundColor: this.color(tipo)
        }}
      >
        <span
          style={{
            fontSize:22, textAlign:'center', fontWeight:'bold'
          }}
        >
          {mensaje}
        </span>
      </div>
    )
  }
}

export default Alerta;
